export type ChatProgressEntry = {
  step?: string;
  tool?: string;
  detail?: string;
  at?: string;
};

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Translated step label plus what the operation is querying, when the backend sent a detail clause. */
export function formatProgressLabel(
  t: Translate,
  step?: string,
  tool?: string,
  detail?: string
): string {
  const base = t(`chat.progress.${step || "tools"}`, {
    defaultValue: t("chat.thinking"),
    tool: tool || "",
  });
  const extra = (detail || "").trim();
  if (!extra) return base;
  const stem = base.replace(/[….]+$/u, "").trim();
  return `${stem}: ${extra}`;
}

export function progressDetailFrom(value: unknown): string | undefined {
  if (!value || typeof value !== "object") return undefined;
  const detail = (value as { detail?: unknown }).detail;
  return typeof detail === "string" && detail.trim() ? detail.trim() : undefined;
}
